$(document).ready(function () {
    if (typeof arrayServises !== 'undefined') {
        $('.type_service_article').val(arrayServises.service_article);
        $('.type_service_id').val(arrayServises.service_id);
        $('.type_service_city').val(arrayServises.city_id);
        $('.type_service_address').val(arrayServises.address_id);

        $(document).on('click', '.js_input_button_city', function () {
            $(this).toggleClass('open');
            $(this).closest('.input_drop').children('.js_drop_city').toggleClass('open');

            $('.js_drop_address, .js_input_button_address, .js_drop_service, .js_input_button_service').removeClass('open');
            $('.js_input_button_city').removeClass('js__stop');
        });

        $(document).on('click', '.js_drop_point_city', function () {
            const name = $(this).text().trim();
            const nameGTM = $(this).attr('data-nameGtm');
            const id = $(this).attr('data-value');
            arrayServises.city_id = id;

            const addressText = $(`.js_drop_address[data-parentblockcity=${id}] li button`).first()
                .text().trim();
            const addressId = $(`.js_drop_address[data-parentblockcity=${id}] li button`).first()
                .attr('data-value');

            const addressPhone = $(`.js_drop_address[data-parentblockcity=${id}] li button`).first()
                .attr('data-phone');

            const addressTextGtm = $(`.js_drop_address[data-parentblockcity=${id}] li button`).first()
                .attr('data-nameGtm').trim();

            let serviceText = "",
                serviceId = "",
                serviceArticle = "",
                serviceTextGTM = "";

            if (arrayServises.service_id != "" && $(`.js_drop_service[data-parentBlockCity=${id}][data-parentBlockAddress=${addressId}] li button[data-services=${arrayServises.service_id}]`).length > 0) {
                serviceText = $(
                    `.js_drop_service[data-parentBlockCity=${id}][data-parentBlockAddress=${addressId}] li button[data-services=${arrayServises.service_id}]`
                ).first().text().trim();
                serviceId = $(
                    `.js_drop_service[data-parentBlockCity=${id}][data-parentBlockAddress=${addressId}] li button[data-services=${arrayServises.service_id}]`
                ).first().attr('data-services');
                serviceArticle = $(
                    `.js_drop_service[data-parentBlockCity=${id}][data-parentBlockAddress=${addressId}] li button[data-services=${arrayServises.service_id}]`
                ).first().attr('data-article');
                serviceTextGTM = $(
                    `.js_drop_service[data-parentBlockCity=${id}][data-parentBlockAddress=${addressId}] li button[data-services=${arrayServises.service_id}]`
                ).first().attr('data-nameGtm');
            } else {
                serviceText = $(
                    `.js_drop_service[data-parentBlockCity=${id}][data-parentBlockAddress=${addressId}] li button`
                ).first().text().trim();
                serviceId = $(
                    `.js_drop_service[data-parentBlockCity=${id}][data-parentBlockAddress=${addressId}] li button`
                ).first().attr('data-services');
                serviceArticle = $(
                    `.js_drop_service[data-parentBlockCity=${id}][data-parentBlockAddress=${addressId}] li button`
                ).first().attr('data-article');
                serviceTextGTM = $(
                    `.js_drop_service[data-parentBlockCity=${id}][data-parentBlockAddress=${addressId}] li button`
                ).first().attr('data-nameGtm');
            }

            arrayServises.address_id = addressId;
            arrayServises.service_id = serviceId;
            arrayServises.service_article = serviceArticle;
            if (addressPhone != "") {
                arrayServises.phone_address = addressPhone;
                $('.js__phone_numder_sto').attr('href', `tel: ${addressPhone}`).text(addressPhone);
            }

            if ($(this).hasClass('js_modal_address')) {
                $('.modal_service_city').val(id);
                $('.js__gtm_data_hidden').attr({ 'data-address': addressTextGtm, 'data-city': nameGTM });
                $('.modal_service_address').val(arrayServises.address_id)
            }

            $('.js_input_button_city').attr('data-valueButton', id).text(name).removeClass('open');
            $('.js_input_button_address').attr({
                'data-parent': id,
                'data-valuebutton': addressId,
                'data-phone': addressPhone,
            }).text(addressText);
            $('.js_input_button_service').attr({
                'data-parent': id,
                'data-parentAddress': addressId,
                'data-valueButton': serviceId,
                'data-article': serviceArticle
            }).text(serviceText);

            $('.js_drop_city').removeClass('open');
            $('.type_service_article').val(arrayServises.service_article);
            $('.type_service_id').val(arrayServises.service_id);
            $('.type_service_city').val(arrayServises.city_id);
            $('.type_service_address').val(arrayServises.address_id);
            $('.js__gtm_data_hidden.js__send_form').attr({ 'data-city': nameGTM, 'data-address': addressTextGtm, 'data-service': serviceTextGTM });
            removeOpen();

            $('.js_open_сity').addClass('js__stop');
            if (!$('.js_input_button_city').hasClass('js__stop')) {
                $(`.js__main_page_city_select[data-value=${id}]`).trigger('click');
            }
        });

        $(document).on('click', '.js_input_button_address', function () {
            $(this).toggleClass('open');
            $(`.js_drop_address[data-parentBlockCity=${arrayServises.city_id}]`).toggleClass('open');

            $('.js_drop_city, .js_drop_service, .js_input_button_city, .js_input_button_service').removeClass('open');
            $('.js_input_button_address').removeClass('js__stop');
        });

        $(document).on('click', '.js_drop_point_address', function () {
            const name = $(this).text();
            const nameGTM = $(this).attr('data-nameGtm');
            const id = $(this).attr('data-value');
            const parent = $(this).attr('data-parent');
            const phone = $(this).attr('data-phone');

            arrayServises.city_id = parent;
            arrayServises.address_id = id;
            if (phone != "") {
                arrayServises.phone_address = phone;
                $('.js__phone_numder_sto').attr('href', `tel: ${phone}`).text(phone);
            }

            let serviceText = "",
                serviceId = "",
                serviceArticle = "",
                serviceTextGTM = "";

            if (arrayServises.service_id != "" && $(`.js_drop_service[data-parentBlockCity=${parent}][data-parentBlockAddress=${id}] li button[data-services=${arrayServises.service_id}]`).length > 0) {
                serviceText = $(
                    `.js_drop_service[data-parentBlockCity=${parent}][data-parentBlockAddress=${id}] li button[data-services=${arrayServises.service_id}]`
                ).first().text();
                serviceId = $(
                    `.js_drop_service[data-parentBlockCity=${parent}][data-parentBlockAddress=${id}] li button[data-services=${arrayServises.service_id}]`
                ).first().attr('data-services');
                serviceArticle = $(
                    `.js_drop_service[data-parentBlockCity=${parent}][data-parentBlockAddress=${id}] li button[data-services=${arrayServises.service_id}]`
                ).first().attr('data-article');
                serviceTextGTM = $(
                    `.js_drop_service[data-parentBlockCity=${parent}][data-parentBlockAddress=${id}] li button[data-services=${arrayServises.service_id}]`
                ).first().attr('data-nameGtm');
            } else {
                serviceText = $(
                    `.js_drop_service[data-parentBlockCity=${parent}][data-parentBlockAddress=${id}] li button`
                ).first().text();
                serviceId = $(
                    `.js_drop_service[data-parentBlockCity=${parent}][data-parentBlockAddress=${id}] li button`
                ).first().attr('data-services');
                serviceArticle = $(
                    `.js_drop_service[data-parentBlockCity=${parent}][data-parentBlockAddress=${id}] li button`
                ).first().attr('data-article');
                serviceTextGTM = $(
                    `.js_drop_service[data-parentBlockCity=${parent}][data-parentBlockAddress=${id}] li button`
                ).first().attr('data-nameGtm');
            }

            arrayServises.service_id = serviceId;
            arrayServises.service_article = serviceArticle;

            $('.js_input_button_address').attr({
                'data-valueButton': id,
                'data-parent': parent,
                'data-phone': phone,
            }).text(name).removeClass('open');
            $('.js_input_button_service').attr({
                'data-parent': parent,
                'data-parentAddress': id,
                'data-valueButton': serviceId,
                'data-article': serviceArticle
            }).text(serviceText);
            $('.js_drop_address').removeClass('open');
            $('.type_service_article').val(arrayServises.service_article);
            $('.type_service_id').val(arrayServises.service_id);
            $('.type_service_city').val(arrayServises.city_id);
            $('.type_service_address').val(arrayServises.address_id);
            $('.js__gtm_data_hidden.js__send_form').attr({ 'data-address': nameGTM, 'data-service': serviceTextGTM });

            if ($(this).hasClass('js_modal_address')) {
                $('.modal_service_address').val(id);
                $('.js__gtm_data_hidden').attr({ 'data-address': nameGTM });
            }

            $('.js_open_address').addClass('js__stop');
            removeOpen();
        });

        $(document).on('click', '.js_drop_point_service', function () {
            const name = $(this).text();
            const nameGTM = $(this).attr('data-nameGtm');
            const id_service = $(this).attr('data-services');
            const article_service = $(this).attr('data-article');
            const id_city = $(this).attr('data-parent');
            const id_address = $(this).attr('data-value');

            arrayServises.city_id = id_city;
            arrayServises.address_id = id_address;
            arrayServises.service_id = id_service;
            arrayServises.service_article = article_service;

            $('.js_input_button_service').attr({
                'data-parent': id_city,
                'data-parentAddress': id_address,
                'data-valueButton': id_service,
                'data-article': article_service
            }).text(name).removeClass('open');

            $('.js_drop_service').removeClass('open');
            $('.type_service_article').val(arrayServises.service_article);
            $('.type_service_id').val(arrayServises.service_id);
            $('.type_service_city').val(arrayServises.city_id);
            $('.type_service_address').val(arrayServises.address_id);
            $('.js__gtm_data_hidden.js__send_form').attr({ 'data-service': nameGTM });
            removeOpen();
        });

        let objectCitySelet = {
            'id_sity': '',
            'id_address': ''
        };

        $(document).on('click', '.js__main_page_city_select', function () {
            if (!$('.js_open_сity').hasClass('js__stop')) {
                const city_id = $(this).attr('data-value');
                $(`.js_drop_point_city[data-value=${city_id}]`).trigger('click');
                objectCitySelet.id_sity = city_id;
            }

            $('.js_input_button_city').addClass('js__stop');
        });

        function servicesView() {
            const idServices = $('.js_servise_now').attr('data-idService');
            const idAddress = $('.js_servise_now').attr('data-idAddress');
            const idCity = $('.js_servise_now').attr('data-idCity');

            $(`.js_drop_service[data-parentblockcity=${idCity}][data-parentblockaddress=${idAddress}]`)
                .find(`.js_drop_point_service[data-parent=${idCity}][data-value=${idAddress}][data-services=${idServices}]`)
                .first().trigger('click');
        }

        if ($('.js_services_portfolio').length == 1) {
            servicesView();
        }

        if ($('.js_services_cat').length == 1) {
            setTimeout(servicesView, 500);
        }

        function removeOpen() {
            $('.js_drop_city').removeClass('open');
            $('.js_drop_address').removeClass('open');
            $('.js_drop_service').removeClass('open');
            $('.js_input_button_city').removeClass('open');
            $('.js_input_button_address').removeClass('open');
            $('.js_input_button_service').removeClass('open');
        }
    }

    $(document).on('click', '.js_input_button_service', function () {
        $(this).toggleClass('open');

        if (typeof arrayServises !== 'undefined') {
            $(`.js_drop_service[data-parentBlockCity=${arrayServises.city_id}][data-parentBlockAddress=${arrayServises.address_id}]`)
                .toggleClass('open');
            $('.js_drop_city, .js_drop_address, .js_input_button_address, .js_input_button_city').removeClass('open');
        }

        const parent = $(this).closest('.sign_service_service');
        parent.find('.js_drop_servise').toggleClass('open');
    });

    $(document).on('click', '.js_drop_servise li', function () {
        const dataLi = {
            'id': $(this).attr('data-id'),
            'article': $(this).attr('data-article'),
            'name': $(this).find('span').text().trim(),
            'ru_lang': $(this).find('span').attr('data-nameGtm')
        }
        const parent = $(this).closest('.js__buy_one_click_modal');

        parent.find('.js_input_button_service')
            .attr('data-valueButton', dataLi['id'])
            .text(dataLi['name'])
            .removeClass('open');
        parent.find('.js_modal_service_article').val(dataLi['article']);
        parent.find('.js__modal_type_service_id').val(dataLi['id']);
        parent.find('.js_drop_servise').removeClass('open');
        $('.modal_wrap[data-modal="callbackServiceAddress"] .js__gtm_data_hidden').attr('data-service', dataLi['ru_lang'])
    });

    $(document).on('click', '.input_drop_points button', function () {
        $(this).closest('.js_form_validate').find('.js__disabled').removeClass('js__disabled');
    })

    $(document).on('click', '.js__address_container_btn', function () {
        $('.js__address_container').removeClass('active');
        const id = $(this).attr('data-id');
        $(`.js__address_container[data-id=${id}]`).addClass('active');

        slickServis(id);
    });

    $(document).on('click', '.js__main_page_city_select', function (e) {
        let city_id = $(this).attr('data-value');
        loadCity(city_id);
    });
});

function loadCity(city_id = null, firsLoad = false) {
    $.post(request.loadCity, {
        "city_id": city_id,
        "lang": lang
    }, function (data) {
        if (data.status == 'ok') {
            if (city_id != null) {
                $(".js__header_city_select").val(city_id);
            }
            $(".js__city_outer").empty().append(data.html);

            if ($('.js__address_container.active').length < 1) {
                const id = $(".js__address_container").first().attr('data-id');
                $(`.js__address_container[data-id=${id}]`).addClass('active');
            }

            $(`.js__main_page_city_select[data-value=${city_id}]`).addClass('js_active');

            const id = $(".js__address_container.active").attr('data-id');

            if (data.change_phone != "") {
                $('.js__phone_numder_sto').attr('href', `tel: ${data.change_phone}`).text(data
                    .change_phone);
            }

            slickServis(id);

            if (typeof contactPage !== 'undefined') {
                myMap($('.js__main_page_city_select.js_active').attr('data-value'));
            }
        }
    });
}

function slickServis(id) {
    $(`.js__address_container[data-id=${id}] .js_slick_servis_photo`).removeClass('slick-initialized slick-slider');
    $(`.js__address_container[data-id=${id}] .js_slick_servis_photo`).each(function () {
        $(this).slick({
            lazyLoad: 'ondemand',
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: `<div class="arrow-prew"></div>`,
            nextArrow: `<div class="arrow-next"></div>`,
        });
    });
}

window.loadCity = loadCity;